<template>
  <div>
    <datetime
      placeholder="Click to Pick date and time"
      class="datetime-style"
      type="datetime"
      v-model="datetime"
      use12-hour
    ></datetime>
    <v-textarea label="Description" v-model="description" rows="3"></v-textarea>
    <v-select
      v-model="priority"
      :items="priorities"
      item-text="value"
      item-value="key"
      menu-props="auto"
      label="Priority"
      required
    />
    <v-btn
      color="green"
      class="white--text"
      :disabled="!datetime"
      @click="create"
      >Create</v-btn
    >
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "FollowUpForm",
  data() {
    return {
      datetime: "Select date",
      description: null,
      priority: 3,
    };
  },
  components: {},
  props: ["lead_id", "user_id"],
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    ...mapMutations({
      SET_NECESSARY_DIALOG: "followups/SET_NECESSARY_DIALOG",
      SET_UNCOMPLETED_LEAD: "auth/SET_UNCOMPLETED_LEAD",
    }),
    create() {
      if (+new Date(this.datetime) <= +new Date()) {
        this.showHandlerSnackbar({
          color: "red",
          text: "Please pick a correct date and time",
          show: true,
        });
      } else if (this.followups.length == 1) {
        this.showHandlerSnackbar({
          color: "red",
          text: "You reached max number of followups",
          show: true,
        });
      } else {
        this.$axios
          .post("/followup/create", {
            user_id: this.user_id,
            lead_id: this.lead_id,
            datetime: this.datetime,
            priority: this.priority,
            description: this.description,
          })
          .then((res) => {
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
            this.datetime = null;
            this.description = null;
          })
          .catch((err) => {
            this.showHandlerSnackbar({
              color: err.response.data.status,
              text: err.response.data.message,
              show: true,
            });
          });
      }
    },
  },
  computed: {
    ...mapGetters({
      followups: "followups/followups",
      priorities: "followups/priorities",
    }),
  },
};
</script>

<style>
.datetime-style {
  border-bottom: 1px solid black;
  width: 200px;
  padding: 5px 0px;
}
</style>